import AdyenACHForm from './adyen-ach-form';

export default AdyenACHForm;
